export default "__VITE_PUBLIC_ASSET__9210573b__"